import {
  ToucanButton,
  ToucanSettingsPart,
  ToucanSettingsSection,
} from "toucan";

/**
 * Music's own section of Settings: whether the Spotify account is connected,
 * and the way to change that. A connect leaves the page for Spotify.
 */
export function SpotifySettings({
  connected,
  onConnect,
  onDisconnect,
}: {
  connected: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
}) {
  return (
    <ToucanSettingsSection heading="Spotify">
      <ToucanSettingsPart>
        <p>
          {connected
            ? "Connected. Music plays through Spotify on any of your devices."
            : "Not connected."}
        </p>
        {connected ? (
          <ToucanButton onClick={onDisconnect}>Disconnect</ToucanButton>
        ) : (
          <ToucanButton onClick={onConnect}>Connect</ToucanButton>
        )}
      </ToucanSettingsPart>
    </ToucanSettingsSection>
  );
}
